import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-action-practice',
  templateUrl: './dialog-action-practice.component.html',
  styleUrls: ['./dialog-action-practice.component.scss'],
})
export class DialogActionPracticeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
